<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="success" class="ml-3">
        Novo Processo de Pagamento
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title">Novo processo de pagamento</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="limpar" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <!-- <v-alert
          type="error"
          v-if="!reports.length > 0 && !administrativeReports.length > 0"
        >
          <v-row>
            <v-col
              >Não exitem relatórios para criar um processo de pagamento</v-col
            >
          </v-row>
        </v-alert> -->

        <v-row>
          <v-col>
            <v-text-field
              label="Número do relatório"
              name="numero"
              type="number"
              required
              :readonly="true"
              v-model="payload.numero"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Total de relatórios"
              name="total"
              type="number"
              required
              :readonly="true"
              v-model="payload.contratos.qtdEntregasPrevistas"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <ComboboxContratoByUser
              :filter="payload"
              :user="user.usuarioId"
              @onChange="loadContrato"
            ></ComboboxContratoByUser>
            <!-- <v-text-field
              label="Código da Contratação"
              name="codigocontratacao"
              type="text"
              required
              v-model="payload.codigoContratacao"
            ></v-text-field> -->
          </v-col>
        </v-row>
        <v-row v-if="contrato && contrato.contratoId">
          <v-col>
            <v-text-field
              label="Ínicio do contrato"
              name="iniContrato"
              type="text"
              v-mask="'##/##/####'"
              disabled
              v-model="contrato.inicioString"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Fim do contrato"
              name="fimContrato"
              type="text"
              v-mask="'##/##/####'"
              disabled
              v-model="contrato.fimString"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              label="Período de Realização (dd/mm/yyyy - dd/mm/yyyy)"
              name="realizacao"
              type="text"
              v-mask="'##/##/#### - ##/##/####'"
              required
              v-model="payload.periodoRealizacao"
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- Remoção a pedido do everton em 03/05/21 -->
        <!-- <v-row>
          <v-col>
            <v-file-input
              multiple
              label="Selecione Arquivos de Anexo"
              v-model="payload.arquivosEnviados"
              @change="loadFiles()"
            >
            </v-file-input>
          </v-col>
        </v-row> -->

        <!-- <v-row>
          <v-col>
            <h2>Arquivos anexados no processo de pagamento</h2>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-data-table
              :headers="headersFiles"
              :items="payload.arquivos"
              item-key="name"
              class="elevation-1"
              hide-default-footer
              disable-pagination
            >
              <template v-slot:item="props">
                <tr>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.type }}</td>
                  <td>
                    <v-btn
                      color="error"
                      class="mr-3"
                      @click="removeFile(props.item)"
                    >
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template slot="no-data">
                <span>
                  Nenhum arquivo anexado
                </span>
              </template>
            </v-data-table>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col>
            <h2>Execução do trabalho: {{ payload.horas }} h</h2>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <h2>
              Relatórios disponíveis para abertura de processo de pagamento
            </h2>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="reports"
              v-model="selectedPayments"
              item-key="relatorioId"
              class="elevation-1"
              hide-default-footer
              disable-pagination
              :show-select="true"
            >
              <template slot="no-data">
                <span> Nenhum relatório retornado </span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <template
          v-if="
            !config.ocultarRelatorioAdministrativos &&
            !groupsConfig.ocultarRelatorioAdministrativos
          "
        >
          <v-row>
            <v-col>
              <h2>
                Relatórios administrativos disponíveis para abertura de processo
                de pagamento
              </h2>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-data-table
                :headers="headersAdministrativeReport"
                :items="administrativeReports"
                v-model="selectedAdministrativePayments"
                item-key="relatorioAdministrativoId"
                class="elevation-1"
                hide-default-footer
                disable-pagination
                :show-select="true"
              >
                <template slot="no-data">
                  <span> Nenhum relatório administrativo retornado </span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="limpar">Fechar</v-btn>
        <v-btn color="info" outlined text @click="createPaymentProcess()"
          >Confirmar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { reportAPI } from "@/modules/report";
import { administrativeReportAPI } from "@/modules/administrative-report";
import { mapActions, mapGetters } from "vuex";
import { paymentReportManagementAPI } from "@/modules/payment-management";
import ComboboxContratoByUser from "@/modules/contratos/components/ComboboxByUser.vue";
import moment from "moment";
export default {
  name: "AppModalInsertPayment",

  components: {
    ComboboxContratoByUser,
  },
  data() {
    return {
      dialog: false,
      reports: [],
      headers: [
        {
          text: "#",
          value: "relatorioId",
        },
        {
          text: "Título",
          value: "titulo",
        },
        {
          text: "Município",
          value: "municipio.nome",
        },
        {
          text: "Criador",
          value: "usuario.nome",
        },
        {
          text: "Horas",
          value: "horasTarefas",
        },
      ],
      selectedPayments: [],
      payload: {
        relatorios: [],
        arquivos: [],
        arquivosEnviados: [],
        horas: 0,
        contratos: {},
        periodoRealizacao: "",
        numero: null,
        total: null,
      },
      headersFiles: [
        {
          text: "Nome",
          value: "name",
        },
        {
          text: "Formato",
          value: "type",
        },
        {
          text: "Ações",
        },
      ],
      contrato: {},
      obrigatorio: (v) => !!v || "Campo Obrigatório",

      headersAdministrativeReport: [
        {
          text: "#",
          value: "relatorioAdministrativoId",
        },
        {
          text: "Título",
          value: "titulo",
        },
        {
          text: "Município",
          value: "municipio.nome",
        },
        {
          text: "Criador",
          value: "usuario.nome",
        },
        {
          text: "Horas",
          value: "horas",
        },
      ],
      administrativeReports: [],
      selectedAdministrativePayments: [],
    };
  },
  computed: {
    ...mapGetters(["isGov", "user", "config", "groupsConfig"]),
  },
  mounted() {
    if (this.isGov) {
      this.headersAdministrativeReport = [
        {
          text: "#",
          value: "relatorioAdministrativoId",
        },
        {
          text: "Título",
          value: "titulo",
        },
        {
          text: "Projeto",
          value: "municipio.nome",
        },
        {
          text: "Criador",
          value: "usuario.nome",
        },
        {
          text: "Horas",
          value: "horas",
        },
      ];

      this.headers = [
        {
          text: "#",
          value: "relatorioId",
        },
        {
          text: "Título",
          value: "titulo",
        },
        {
          text: "Projeto",
          value: "municipio.nome",
        },
        {
          text: "Criador",
          value: "usuario.nome",
        },
        {
          text: "Horas",
          value: "horasTarefas",
        },
      ];
    }
  },
  created() {
    // this.getReports();
    //this.getAdministrativeReports();
  },
  methods: {
    ...mapActions(["setLoading"]),
    isValidDate(d, m, y) {
      const date = new Date(y, m - 1, d);
      return (
        date.getFullYear() === parseInt(y) &&
        date.getMonth() === m - 1 &&
        date.getDate() === parseInt(d)
      );
    },
    periodoValido(input) {
      const regex = /^(\d{2})\/(\d{2})\/(\d{4}) - (\d{2})\/(\d{2})\/(\d{4})$/;
      const match = input.match(regex);

      if (!match) return "Periodo inválido";

      const [_, d1, m1, y1, d2, m2, y2] = match.map(Number);

      if (!this.isValidDate(d1, m1, y1) || !this.isValidDate(d2, m2, y2))
        return "Periodo inválido";

      const date1 = new Date(y1, m1 - 1, d1);
      const date2 = new Date(y2, m2 - 1, d2);

      if (date2 < date1)
        return "O período final não pode ser menor que o inicial";

      if (this.contrato && this.contrato.inicio && this.contrato.fim) {
        const inicioContrato = new Date(this.contrato.inicio);
        const fimContrato = new Date(this.contrato.fim);

        if (date1 < inicioContrato || date2 > fimContrato) {
          return "O período de Realização deve estar entre o início e o fim do contrato";
        }
      }

      if (this.payload.ultimoPeriodo) {
        const matchPeriodo = this.payload.ultimoPeriodo.match(regex);

        if (!matchPeriodo) return;

        const [_, d1p, m1p, y1p, d2p, m2p, y2p] = matchPeriodo.map(Number);

        const date2Periodo = new Date(y2p, m2p - 1, d2p);
        if (date1 < date2Periodo) {
          return `Favor criar um novo processo de pagamento com o período inicial maior que o último período do processo de pagamento anterior (${this.payload.ultimoPeriodo}).  `;
        }
      }

      return;
    },

    getReports(e) {
      this.setLoading(true);

      reportAPI
        .getByUser(this.$route.params.id, e)
        .then((resp) => {
          this.reports = resp.data;

          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatórios");
        });
    },
    createPaymentProcess() {
      this.payload.codigoContratacao = this.payload.contratos.numContrato;
      this.payload.contratoId = this.payload.contratos.contratoId;

      this.payload.total = this.payload.contratos.qtdEntregasPrevistas;
      if (
        this.selectedPayments.length === 0 &&
        this.selectedAdministrativePayments.length === 0
      ) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem relatórios!"
        );
      } else if (!this.payload.codigoContratacao) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem código de contratação!"
        );
      } else if (!this.payload.periodoRealizacao) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem período de realização!"
        );
      } else if (
        this.payload.periodoRealizacao &&
        this.periodoValido(this.payload.periodoRealizacao)
      ) {
        this.$notification.error(
          this.periodoValido(this.payload.periodoRealizacao)
        );
      } else if (!this.payload.numero) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem colocar o número do relatório!"
        );
      } else if (!this.payload.total) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem o total de relatórios!"
        );
      } else {
        this.setLoading(true);

        let formData = new FormData();

        if (this.payload.arquivos.length > 0) {
          for (let i = 0; i < this.payload.arquivos.length; i++) {
            formData.append("arquivos", this.payload.arquivos[i]);
          }
        }

        formData.append(
          "relatoriosString",
          JSON.stringify(this.selectedPayments)
        );
        formData.append(
          "relatoriosAdministrativosString",
          JSON.stringify(this.selectedAdministrativePayments)
        );
        formData.append("contratoId", this.payload.contratoId);

        formData.append("codigoContratacao", this.payload.codigoContratacao);
        formData.append("periodoRealizacao", this.payload.periodoRealizacao);
        formData.append("horas", this.payload.horas);
        formData.append("numero", this.payload.numero);
        formData.append("total", this.payload.total);

        paymentReportManagementAPI
          .create(formData)
          .then((resp) => {
            this.limpar();
            this.$emit("onAddPayment");
            this.setLoading(false);
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao inserir processo de pagamento");
          });
      }
    },
    loadFiles() {
      if (this.payload.arquivosEnviados.length > 0) {
        this.payload.arquivosEnviados.forEach((arquivo) => {
          this.payload.arquivos.push(arquivo);
        });
      }
    },
    removeFile(file) {
      this.payload.arquivos = this.payload.arquivos.filter(
        (item) => item !== file
      );
    },
    limpar() {
      this.dialog = false;
      this.payload = {
        relatorios: [],
        arquivos: [],
        arquivosEnviados: [],
        horas: 0,
        contratos: {},
        periodoRealizacao: "",
        numero: null,
        total: null,
      };
      this.selectedPayments = [];
      this.selectedAdministrativePayments = [];
      this.contrato = {};
    },
    getNumeroRelatorio(e) {
      this.setLoading(true);
      paymentReportManagementAPI
        .getNumeroRelatorio(this.$route.params.id, e)
        .then((resp) => {
          this.payload.numero = resp.data ? resp.data.quantidadeAtual : 1;
          this.payload.ultimoPeriodo = resp.data
            ? resp.data.ultimoPeriodo
            : null;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatórios administrativos");
        });
    },
    getAdministrativeReports(e) {
      this.setLoading(true);

      administrativeReportAPI
        .getByUser(this.$route.params.id, e)
        .then((resp) => {
          this.administrativeReports = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatórios administrativos");
        });
    },
    loadContrato(e) {
      if (!e) {
        this.contrato = {};
        this.selectedPayments = [];
        this.selectedAdministrativePayments = [];
        return;
      }

      let contratoid = e.contratoId;
      this.contrato = e;
      this.payload.contratos = e; // Atualiza o payload com o contrato selecionado
      this.contrato.inicioString = moment(e.inicio).format("DD/MM/YYYY");
      this.contrato.fimString = moment(e.fim).format("DD/MM/YYYY");
      this.selectedPayments = [];
      this.selectedAdministrativePayments = [];
      if (contratoid) {
        this.getReports(contratoid);
        this.getAdministrativeReports(contratoid);
        this.getNumeroRelatorio(contratoid);
      }
    },
  },
  watch: {
    selectedPayments: function (newValue) {
      this.payload.horas = 0;
      newValue.forEach((relatorio) => {
        this.payload.horas += relatorio.horasTarefas;
      });
      this.selectedAdministrativePayments.forEach((relatorio) => {
        this.payload.horas += relatorio.horas;
      });
    },
    selectedAdministrativePayments: function (newValue) {
      this.payload.horas = 0;
      newValue.forEach((relatorio) => {
        this.payload.horas += relatorio.horas;
      });
      this.selectedPayments.forEach((relatorio) => {
        this.payload.horas += relatorio.horasTarefas;
      });
    },
  },
};
</script>
